import { createStore } from "vuex";
import auth from './modules/auth';
import gas from './modules/gas';
import settings from './modules/settings';

export default function({ apolloClient }) {
  return createStore({
    state: {
      isLoggedIn: false,
      isConnected: false,
      passBalance: 0,
      isDiscordLinked: false,
      premiumExpiresAt: null,
      isPremium: process.env.VUE_APP_IS_PREMIUM_DEFAULT === 'true',
      user: {
        id: null,
      }
    },
    getters: {
      isPremium(state) {
        return state.isPremium;
      }
    },
    mutations: {
      setUser(state, {user, isLoggedIn = false, isPremium = false, isDiscordLinked = false, passBalance = 0, premiumExpiresAt = null}) {
        state.user = user;
        state.isConnected = !!user.id;
        state.isLoggedIn = isLoggedIn;
        state.isPremium = isPremium;
        state.isDiscordLinked = isDiscordLinked;
        state.passBalance = passBalance
        state.premiumExpiresAt = premiumExpiresAt;
      },
      setIsLoggedIn(state, value) {
        state.isLoggedIn = value;
      }
    },
    actions: {
      checkAuth({commit}) {
        commit('setIsLoggedIn', false)
      },
      logout({commit}) {
        commit('setUser', {user: {id: null}, isLoggedIn: false, isPremium: false});
      }
    },
    modules: {
      auth: auth({ apolloClient }),
      settings: settings(),
      gas: gas(),
    }
  });
}
